import React from 'react';

import { AlertProps } from './Alert.type';

const Alert = (props: AlertProps) => {
	if (props.showAlert) {
		return (
			<div className="flex items-start bg-danger-default rounded-xl p-2.5 mb-6">
				<img src="/images/info.svg" className="mr-3" />
				<div className="text-white text-large text-left font-interMedium">
					{props.text}
				</div>
			</div>
		);
	}
	return null;
};

export default Alert;
